<template>
  <div class="view welcome" @click="start">
    <!-- ─── Scena animată de fundal ─── -->
    <div class="scene" aria-hidden="true">
      <!-- Fascicule de lumină înclinate (panouri de sticlă) -->
      <div class="beam beam--l1"></div>
      <div class="beam beam--l2"></div>
      <div class="beam beam--r1"></div>
      <div class="beam beam--r2"></div>

      <!-- Ceață aurorală difuză în spatele șuvoaielor -->
      <div class="mist mist--left"></div>
      <div class="mist mist--right"></div>

      <!-- Râuri de lumină care curg de sus în lacul din centru-jos.
           Fiecare șuvoi are un traseu de bază (slab) + o copie "puls" pe care
           o dâră luminoasă chiar călătorește în jos, spre lac. -->
      <svg class="waves waves--left" viewBox="0 0 500 900" fill="none" preserveAspectRatio="none">
        <defs>
          <linearGradient id="wlg-a" x1="0" y1="0" x2="500" y2="900" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#60a5fa" stop-opacity="0.15" />
            <stop offset="0.45" stop-color="#a855f7" stop-opacity="0.9" />
            <stop offset="0.8" stop-color="#c084fc" stop-opacity="0.85" />
            <stop offset="1" stop-color="#7c3aed" stop-opacity="0.3" />
          </linearGradient>
        </defs>

        <!-- trasee de bază, abia vizibile -->
        <path class="stream stream--base" d="M20 -30 C 90 200, 40 420, 200 620 S 430 800, 500 850" />
        <path class="stream stream--base" d="M90 -50 C 170 180, 110 400, 260 600 S 460 780, 520 830" />
        <path class="stream stream--base" d="M-40 60 C 60 260, 20 480, 170 660 S 420 830, 500 880" />
        <path class="stream stream--base" d="M160 -60 C 240 160, 180 380, 320 580 S 480 760, 540 810" />
        <path class="stream stream--base" d="M-70 200 C 40 340, 10 520, 150 700 S 400 860, 480 900" />

        <!-- pulsuri de lumină care curg în jos, spre lac -->
        <path class="stream stream--pulse stream--pulse-1" d="M20 -30 C 90 200, 40 420, 200 620 S 430 800, 500 850" />
        <path class="stream stream--pulse stream--pulse-2" d="M90 -50 C 170 180, 110 400, 260 600 S 460 780, 520 830" />
        <path class="stream stream--pulse stream--pulse-3" d="M-40 60 C 60 260, 20 480, 170 660 S 420 830, 500 880" />
        <path class="stream stream--pulse stream--pulse-4" d="M160 -60 C 240 160, 180 380, 320 580 S 480 760, 540 810" />

        <!-- panglici ondulate pe marginea de jos, ca apa care se așază -->
        <path class="ribbon ribbon--1" d="M-60 450 C 70 415, 55 505, 190 480 S 350 545, 470 585" />
        <path class="ribbon ribbon--2" d="M-60 500 C 80 460, 60 560, 200 530 S 360 600, 480 640" />
        <path class="ribbon ribbon--3" d="M-60 560 C 90 520, 70 620, 210 590 S 370 660, 490 700" />
        <path class="ribbon ribbon--4" d="M-60 620 C 100 580, 80 680, 220 650 S 380 720, 500 760" />
      </svg>
      <svg class="waves waves--right" viewBox="0 0 500 900" fill="none" preserveAspectRatio="none">
        <path class="stream stream--base" d="M20 -30 C 90 200, 40 420, 200 620 S 430 800, 500 850" />
        <path class="stream stream--base" d="M90 -50 C 170 180, 110 400, 260 600 S 460 780, 520 830" />
        <path class="stream stream--base" d="M-40 60 C 60 260, 20 480, 170 660 S 420 830, 500 880" />
        <path class="stream stream--base" d="M160 -60 C 240 160, 180 380, 320 580 S 480 760, 540 810" />
        <path class="stream stream--base" d="M-70 200 C 40 340, 10 520, 150 700 S 400 860, 480 900" />
        <path class="stream stream--pulse stream--pulse-1" d="M20 -30 C 90 200, 40 420, 200 620 S 430 800, 500 850" />
        <path class="stream stream--pulse stream--pulse-2" d="M90 -50 C 170 180, 110 400, 260 600 S 460 780, 520 830" />
        <path class="stream stream--pulse stream--pulse-3" d="M-40 60 C 60 260, 20 480, 170 660 S 420 830, 500 880" />
        <path class="stream stream--pulse stream--pulse-4" d="M160 -60 C 240 160, 180 380, 320 580 S 480 760, 540 810" />
        <path class="ribbon ribbon--1" d="M-60 450 C 70 415, 55 505, 190 480 S 350 545, 470 585" />
        <path class="ribbon ribbon--2" d="M-60 500 C 80 460, 60 560, 200 530 S 360 600, 480 640" />
        <path class="ribbon ribbon--3" d="M-60 560 C 90 520, 70 620, 210 590 S 370 660, 490 700" />
        <path class="ribbon ribbon--4" d="M-60 620 C 100 580, 80 680, 220 650 S 380 720, 500 760" />
      </svg>

      <!-- Portal luminos pe podea — "lacul" în care se varsă șuvoaiele -->
      <div class="portal">
        <div class="portal__glow"></div>
        <div class="portal__swirl"></div>
        <div class="portal__ring portal__ring--1"></div>
        <div class="portal__ring portal__ring--2"></div>
        <div class="portal__ring portal__ring--3"></div>
        <div class="portal__ripple portal__ripple--1"></div>
        <div class="portal__ripple portal__ripple--2"></div>
        <div class="portal__ripple portal__ripple--3"></div>
        <div class="portal__core"></div>
      </div>

      <!-- Particule care urcă -->
      <span
        v-for="(p, i) in particles"
        :key="i"
        class="particle"
        :style="{
          left: p.left + '%',
          width: p.size + 'px',
          height: p.size + 'px',
          animationDelay: p.delay + 's',
          animationDuration: p.dur + 's',
        }"
      ></span>

      <div class="scene__floor-fade"></div>
    </div>

    <!-- ─── Conținut ─── -->
    <div class="welcome__content">
      <div class="welcome__logo orbitron">VEEV</div>

      <div class="welcome__top">
        <p class="welcome__eyebrow orbitron">
          THIS ISN'T JUST A FESTIVAL.<br />IT'S A FREQUENCY.
        </p>
        <div class="welcome__divider"></div>
      </div>

      <div class="welcome__middle">
        <h1 class="welcome__title orbitron">
          WHO ARE YOU<br />WHEN THE MUSIC<br />TAKES OVER?
        </h1>

        <div class="welcome__eq">
          <span
            v-for="(h, i) in eqBars"
            :key="i"
            class="welcome__eq-bar"
            :style="{ height: h + 'px', animationDelay: (i * 0.07) + 's' }"
          ></span>
        </div>

        <p class="welcome__discover orbitron">DISCOVER YOUR</p>
        <p class="welcome__alterego orbitron">FESTIVAL ALTER EGO</p>
      </div>

      <div class="welcome__bottom-area">
        <button class="start-btn orbitron" @click.stop="start">
          START EXPERIENCE <span class="start-btn__arrow">→</span>
        </button>
        <p class="welcome__legal orbitron">FOR ADULTS ONLY — 18+</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useSessionStore } from '@/store/session'

const router = useRouter()
const session = useSessionStore()

// Poziții/temporizări generate o singură dată la montare — suficient pentru ambient.
const particles = Array.from({ length: 18 }, () => ({
  left: Math.random() * 100,
  size: 2 + Math.random() * 3,
  delay: Math.random() * 10,
  dur: 9 + Math.random() * 9,
}))

// Bare de egalizator: mai înalte spre centru, cu mică variație aleatoare.
const eqBars = Array.from({ length: 33 }, (_, i) => {
  const falloff = 1 - Math.abs(i - 16) / 22
  return Math.round(5 + falloff * 20 + Math.random() * 8)
})

function start() {
  session.reset()
  session.startSession()
  router.push('/selfie')
}
</script>

<style scoped>
.welcome {
  position: relative;
  gap: 0;
  padding: 0;
  text-align: center;
  cursor: pointer;
  user-select: none;
  background: radial-gradient(ellipse at 50% 120%, #12071f 0%, #06040e 45%, #030309 100%);
  overflow: hidden;
}

/* ─────────── SCENA ─────────── */
.scene {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

/* ─── Fascicule ─── */
.beam {
  position: absolute;
  bottom: -15vh;
  width: 13vw;
  height: 130vh;
  transform-origin: bottom center;
  background: linear-gradient(
    to top,
    rgba(124, 58, 237, 0.32) 0%,
    rgba(88, 101, 242, 0.14) 40%,
    rgba(96, 165, 250, 0.06) 65%,
    transparent 85%
  );
  overflow: hidden;
  filter: blur(1.5px);
}

.beam::before {
  content: '';
  position: absolute;
  inset: -30% -60%;
  background: linear-gradient(
    115deg,
    transparent 42%,
    rgba(168, 85, 247, 0.55) 50%,
    rgba(96, 165, 250, 0.35) 54%,
    transparent 62%
  );
  animation: beamStreak 7s ease-in-out infinite;
}

.beam::after {
  content: '';
  position: absolute;
  inset: 0;
  border-left: 1px solid rgba(200, 170, 255, 0.28);
  border-right: 1px solid rgba(200, 170, 255, 0.16);
}

.beam--l1 { left: 1vw; transform: rotate(-14deg) skewX(-4deg); animation: beamPulse 5s ease-in-out infinite; }
.beam--l2 { left: 13vw; width: 9vw; transform: rotate(-8deg) skewX(-2deg); opacity: 0.7; animation: beamPulse 6.5s ease-in-out 1.2s infinite; }
.beam--r1 { right: 1vw; transform: rotate(14deg) skewX(4deg); animation: beamPulse 5.6s ease-in-out 0.6s infinite; }
.beam--r2 { right: 13vw; width: 9vw; transform: rotate(8deg) skewX(2deg); opacity: 0.7; animation: beamPulse 7s ease-in-out 2s infinite; }

@keyframes beamStreak {
  0%, 100% { transform: translateY(35%); opacity: 0.4; }
  50% { transform: translateY(-35%); opacity: 1; }
}

@keyframes beamPulse {
  0%, 100% { opacity: 0.65; }
  50% { opacity: 1; }
}

/* ─── Ceață aurorală ─── */
.mist {
  position: absolute;
  width: 34vw;
  height: 45vh;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(124, 58, 237, 0.3), rgba(59, 130, 246, 0.1) 55%, transparent 75%);
  filter: blur(50px);
  animation: mistDrift 11s ease-in-out infinite alternate;
}

.mist--left { left: -10vw; bottom: 4vh; }
.mist--right { right: -10vw; bottom: 4vh; animation-delay: 4s; }

@keyframes mistDrift {
  from { transform: translateY(0) scale(1); opacity: 0.7; }
  to { transform: translateY(-7vh) scale(1.18); opacity: 1; }
}

/* ─── Râuri de lumină ─── */
.waves {
  position: absolute;
  bottom: 0;
  width: 52vw;
  height: 100vh;
}

.waves--left { left: 0; }
.waves--right { right: 0; transform: scaleX(-1); }

/* gradientul e definit doar în primul svg; al doilea (dreapta) îl refolosește
   prin url(#wlg-a) — id-urile SVG sunt globale în document */
.stream,
.ribbon {
  stroke: url(#wlg-a);
  fill: none;
  stroke-linecap: round;
}

.stream--base {
  stroke-width: 1.4;
  opacity: 0.3;
}

/* Dâră luminoasă scurtă (dash de 70 dintr-o perioadă de 970) care parcurge
   traseul de sus în jos — dashoffset scade de la o perioadă întreagă la 0,
   deci bucla e perfect continuă. */
.stream--pulse {
  stroke-width: 2.6;
  stroke-dasharray: 70 900;
  filter: drop-shadow(0 0 6px rgba(168, 85, 247, 0.9));
  animation: pulseFlow 5.2s linear infinite;
}

.stream--pulse-2 { animation-duration: 6.4s; animation-delay: 1.4s; stroke-width: 2.2; }
.stream--pulse-3 { animation-duration: 7.6s; animation-delay: 3s; stroke-width: 1.8; }
.stream--pulse-4 { animation-duration: 5.8s; animation-delay: 2.2s; stroke-width: 2.4; }

@keyframes pulseFlow {
  from { stroke-dashoffset: 970; }
  to { stroke-dashoffset: 0; }
}

.ribbon {
  stroke-width: 1.2;
  opacity: 0.35;
  stroke-dasharray: 9 15;
  animation: ribbonFlow 7s linear infinite;
}

.ribbon--2 { animation-duration: 8.5s; opacity: 0.28; }
.ribbon--3 { animation-duration: 6.2s; opacity: 0.4; }
.ribbon--4 { animation-duration: 9.4s; opacity: 0.22; }

@keyframes ribbonFlow {
  to { stroke-dashoffset: -240; }
}

/* ─── Portal ─── */
.portal {
  position: absolute;
  bottom: -3vh;
  left: 50%;
  transform: translateX(-50%);
  width: min(58vw, 860px);
  aspect-ratio: 3 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.portal__glow {
  position: absolute;
  width: 110%;
  height: 130%;
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    rgba(139, 92, 246, 0.5) 0%,
    rgba(88, 101, 242, 0.25) 40%,
    transparent 70%
  );
  filter: blur(24px);
  animation: portalGlow 4s ease-in-out infinite;
}

@keyframes portalGlow {
  0%, 100% { opacity: 0.7; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.06); }
}

.portal__swirl {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    transparent 0deg 18deg,
    rgba(168, 85, 247, 0.55) 45deg,
    transparent 85deg,
    rgba(96, 165, 250, 0.45) 125deg,
    transparent 165deg,
    rgba(217, 70, 239, 0.4) 215deg,
    transparent 255deg,
    rgba(124, 58, 237, 0.5) 300deg,
    transparent 342deg 360deg
  );
  -webkit-mask: radial-gradient(circle, transparent 26%, #000 30% 68%, transparent 72%);
  mask: radial-gradient(circle, transparent 26%, #000 30% 68%, transparent 72%);
  filter: blur(3px);
  animation: swirlSpin 12s linear infinite;
}

@keyframes swirlSpin {
  from { transform: translate(-50%, -50%) scaleY(0.3) rotate(0deg); }
  to { transform: translate(-50%, -50%) scaleY(0.3) rotate(360deg); }
}

.portal__ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(168, 85, 247, 0.55);
  box-shadow: 0 0 18px rgba(139, 92, 246, 0.45), inset 0 0 18px rgba(139, 92, 246, 0.2);
}

.portal__ring--1 { width: 46%; aspect-ratio: 3.2 / 1; animation: ringPulse 3s ease-in-out infinite; }
.portal__ring--2 { width: 68%; aspect-ratio: 3.1 / 1; border-color: rgba(96, 165, 250, 0.4); animation: ringPulse 3s ease-in-out 0.7s infinite; }
.portal__ring--3 { width: 92%; aspect-ratio: 3 / 1; border-color: rgba(168, 85, 247, 0.3); animation: ringPulse 3s ease-in-out 1.4s infinite; }

@keyframes ringPulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

/* valuri care se propagă din centru spre exterior, ca pe apă */
.portal__ripple {
  position: absolute;
  width: 22%;
  aspect-ratio: 3.2 / 1;
  border-radius: 50%;
  border: 1px solid rgba(196, 160, 255, 0.7);
  animation: rippleExpand 4.2s ease-out infinite;
}

.portal__ripple--2 { animation-delay: 1.4s; }
.portal__ripple--3 { animation-delay: 2.8s; }

@keyframes rippleExpand {
  0% { transform: scale(0.3); opacity: 0.9; }
  100% { transform: scale(4.4); opacity: 0; }
}

.portal__core {
  position: absolute;
  width: 30%;
  aspect-ratio: 3.4 / 1;
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    rgba(233, 213, 255, 0.9) 0%,
    rgba(168, 85, 247, 0.55) 35%,
    rgba(88, 101, 242, 0.25) 65%,
    transparent 80%
  );
  filter: blur(6px);
  animation: portalGlow 3s ease-in-out 0.5s infinite;
}

/* ─── Particule ─── */
.particle {
  position: absolute;
  bottom: -2vh;
  border-radius: 50%;
  background: rgba(196, 160, 255, 0.9);
  box-shadow: 0 0 8px rgba(168, 85, 247, 0.9);
  opacity: 0;
  animation: particleRise linear infinite;
}

@keyframes particleRise {
  0% { transform: translateY(0); opacity: 0; }
  12% { opacity: 0.9; }
  75% { opacity: 0.5; }
  100% { transform: translateY(-75vh); opacity: 0; }
}

.scene__floor-fade {
  position: absolute;
  inset: auto 0 0 0;
  height: 34vh;
  background: linear-gradient(to top, rgba(76, 29, 149, 0.18), transparent);
  pointer-events: none;
}

/* ─────────── CONȚINUT ─────────── */
.welcome__content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2.2rem 3rem 2.6rem;
}

.welcome__logo {
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 0.5em;
  color: rgba(255, 255, 255, 0.28);
}

.welcome__top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.welcome__eyebrow {
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.4em;
  line-height: 2;
  color: rgba(255, 255, 255, 0.75);
}

.welcome__divider {
  width: 140px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(168, 85, 247, 0.9), transparent);
  box-shadow: 0 0 10px rgba(168, 85, 247, 0.7);
}

.welcome__middle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
}

.welcome__title {
  font-size: clamp(2.6rem, 6vw, 5.2rem);
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: 0.18em;
  color: #f4f2ff;
  text-shadow:
    0 0 24px rgba(139, 92, 246, 0.65),
    0 0 70px rgba(96, 165, 250, 0.35);
}

.welcome__eq {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 36px;
}

.welcome__eq-bar {
  width: 3px;
  border-radius: 2px;
  background: linear-gradient(to top, #7c3aed, #a855f7, #60a5fa);
  box-shadow: 0 0 6px rgba(168, 85, 247, 0.8);
  animation: eqPulse 1.1s ease-in-out infinite alternate;
}

@keyframes eqPulse {
  from { transform: scaleY(0.35); opacity: 0.6; }
  to { transform: scaleY(1); opacity: 1; }
}

.welcome__discover {
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.5em;
  color: rgba(255, 255, 255, 0.8);
}

.welcome__alterego {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.45em;
  margin-top: -0.8rem;
  background: linear-gradient(90deg, #a855f7, #d946ef, #60a5fa);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 0 14px rgba(168, 85, 247, 0.55));
}

.welcome__bottom-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.4rem;
}

.start-btn {
  padding: 1.15rem 3.6rem;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.3em;
  color: #fff;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 12px;
  background:
    linear-gradient(rgba(8, 8, 22, 0.9), rgba(8, 8, 22, 0.9)) padding-box,
    linear-gradient(90deg, #3b82f6, #a855f7) border-box;
  box-shadow:
    0 0 26px rgba(139, 92, 246, 0.5),
    0 0 70px rgba(59, 130, 246, 0.25),
    inset 0 0 22px rgba(139, 92, 246, 0.12);
  animation: btnBreath 2.6s ease-in-out infinite;
}

@keyframes btnBreath {
  0%, 100% { box-shadow: 0 0 26px rgba(139, 92, 246, 0.5), 0 0 70px rgba(59, 130, 246, 0.25), inset 0 0 22px rgba(139, 92, 246, 0.12); }
  50% { box-shadow: 0 0 44px rgba(139, 92, 246, 0.85), 0 0 100px rgba(59, 130, 246, 0.4), inset 0 0 30px rgba(139, 92, 246, 0.2); }
}

.start-btn__arrow {
  display: inline-block;
  margin-left: 0.7rem;
  animation: arrowNudge 1.6s ease-in-out infinite;
}

@keyframes arrowNudge {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(6px); }
}

.welcome__legal {
  font-size: 0.65rem;
  letter-spacing: 0.35em;
  color: rgba(255, 255, 255, 0.22);
}
</style>
